import Com from "components/styledComp/CommStyledComp";
import React from "react";

const SpdstBackground = () => {
    const strategies = [
        {
            title: "투자보호",
            desc:
                "원격 제어가 가능한 페데스탈을 도입을 검토할 때 이미 도입된 페데스탈을 철거하고 새로 투자를 해야 함",
        },
        {
            title: "관리자 업무 부하 감소",
            desc:
                "원격 조명제어, 전기/수도 원격 제어, 원격 검침, 페데스탈별/사용자별/기간별 매출과 사용량의 확인, 페데스탈 사용 현황 확인, 선석 관리",
        },
        {
            title: "한글 지원",
            desc:
                "완벽한 한글 지원(카카오톡, 경고-플러그빠짐, 과금 내역, 잔액 확인, 공지사항…)",
        },
        {
            title: "시스템 연계",
            desc:
                "선석관리 시스템등과의 연계, 데시보드를 활용한 용이한 관리, 저장된 데이터의 활용, 키오스크 시스템과 연계를 통한 업무 부하 감소",
        },
    ];

    return (
        <Com.DivDetailSection border="true">
        <Com.DivDetailHeading>
            <Com.DetailHeading>sDevice</Com.DetailHeading>
            <Com.DetailHeadingP>에스디바이스</Com.DetailHeadingP>
            <Com.DivDetailHeading>
            <div className="paragraph">
                페데스탈에 장착 되어 전기/수도/조명을 원격 제어및 검침하고 통신하는 장치
            </div>
            </Com.DivDetailHeading>
        </Com.DivDetailHeading>
        <div className="strategy">
            <Com.StrongStrategy>개발배경</Com.StrongStrategy>
        </div>
        <div className="strategy-list">
            {strategies.map((strategy, index) => (
            <div className="background_spd" key={index}>
                <Com.SpanStrategy>{index + 1}</Com.SpanStrategy>
                <div className="strategy-title">
                <Com.StrongStrategy>{strategy.title}</Com.StrongStrategy>
                <p className="strategy-desc">{strategy.desc}</p>
                </div>
            </div>
            ))}
        </div>
        </Com.DivDetailSection>
    );
};

export default SpdstBackground;
